import React, { useState } from "react";
import { connect } from "react-redux";
import Modal from "react-animated-modal";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import Widget from "../Dashboard/Widget";
import GridReportWidget from "../Shared/Reports/GridReportWidget";
import ReportsService from "../../services/DocumentStore/ReportsService";
import MiscellaneousAdministration from "../../services/Management/MiscellaneousAdministration";
import AddWidget from "./AddWidget";
import * as DataGridModule from "devextreme-react/data-grid";

const { loadReport, CSVDownloadReport } = ReportsService;

const { getCustTypes, getRateCardYears } = MiscellaneousAdministration;

var date = new Date();
date.setMonth(date.getMonth() - 1);

const appType = 0;

const Reports = ({ _ }) => {
  const reportItems = [
    {
      id: 7,
      component: GridReportWidget,
      params: {
        reportId: 14,
        reportDataGetter: (p) =>
          loadReport({
            reportId: 14,
            applicationType: appType,
            ...p,
          }),
        reportDownloader: (p) =>
          CSVDownloadReport({
            reportId: 14,
            applicationType: appType,
            ...p,
          }),
        DataGridModule,
        reportName: _.Reports.ReportOfRateCards,
        filterParams: [
          {
            name: "rateCardYears",
            text: "" + _.Reports.ReportOfRateCards,
            type: "select",
            source: () => getRateCardYears(),
          },
        ],
      },
    },
    {
      id: 1,
      component: GridReportWidget,
      params: {
        reportId: 1,
        reportDataGetter: (p) =>
          loadReport({
            reportId: 1,
            applicationType: appType,
            ...p,
          }),
        reportDownloader: (p) =>
          CSVDownloadReport({
            reportId: 1,
            applicationType: appType,
            ...p,
          }),
        reportName: _.Reports.ActivityOfAuthorisedUsersWidget,
        DataGridModule,
        filterParams: [
          { name: "startDate", text: _.StartDate, type: "date", value: date },
          {
            name: "endDate",
            text: _.EndDate,
            type: "date",
            value: new Date(),
          },
        ],
      },
    },
    {
      id: 2,
      component: GridReportWidget,
      params: {
        reportId: 2,
        reportDataGetter: (p) =>
          loadReport({
            reportId: 2,
            applicationType: appType,
            ...p,
          }),
        reportDownloader: (p) =>
          CSVDownloadReport({
            reportId: 2,
            applicationType: appType,
            ...p,
          }),
        DataGridModule,
        reportName: _.Reports.ReportOfInventoryStatusWidget,
        filterParams: [],
      },
    },
    {
      id: 3,
      component: GridReportWidget,
      params: {
        reportId: 3,
        reportDataGetter: (p) =>
          loadReport({
            reportId: 3,
            applicationType: appType,
            ...p,
          }),
        reportDownloader: (p) =>
          CSVDownloadReport({
            reportId: 3,
            applicationType: appType,
            ...p,
          }),
        DataGridModule,
        reportName: _.Reports.ReportOfFileAndItemRetrievalWidget,
        filterParams: [
          { name: "startDate", text: _.StartDate, type: "date", value: date },
          {
            name: "endDate",
            text: _.EndDate,
            type: "date",
            value: new Date(),
          },
        ],
      },
    },
    {
      id: 4,
      component: GridReportWidget,
      params: {
        reportId: 4,
        reportDataGetter: (p) =>
          loadReport({
            reportId: 4,
            applicationType: appType,
            ...p,
          }),
        reportDownloader: (p) =>
          CSVDownloadReport({
            reportId: 4,
            applicationType: appType,
            ...p,
          }),
        DataGridModule,
        reportName: _.Reports.ReportOfExpiredItemsReadyForDestructionWidget,
        filterParams: [
          { name: "startDate", text: _.StartDate, type: "date", value: date },
          {
            name: "endDate",
            text: _.EndDate,
            type: "date",
            value: new Date(),
          },
        ],
      },
    },
    {
      id: 5,
      component: GridReportWidget,
      params: {
        reportId: 5,
        reportDataGetter: (p) =>
          loadReport({
            reportId: 5,
            applicationType: appType,
            ...p,
          }),
        reportDownloader: (p) =>
          CSVDownloadReport({
            reportId: 5,
            applicationType: appType,
            ...p,
          }),
        DataGridModule,
        reportName: _.Reports.ReportOfItemsWithUpcapturedDataWidget,
        filterParams: [
          {
            name: "custTypes",
            text: _.ClientHub.CustomFields,
            type: "select",
            source: () => getCustTypes(),
          },
        ],
      },
    },
    {
      id: 6,
      component: GridReportWidget,
      params: {
        reportId: 6,
        reportDataGetter: (p) =>
          loadReport({
            reportId: 6,
            applicationType: appType,
            ...p,
          }),
        reportDownloader: (p) =>
          CSVDownloadReport({
            reportId: 6,
            applicationType: appType,
            ...p,
          }),
        DataGridModule,
        reportName: _.Reports.ReportOfCompletedWorkOrderWidget,
        filterParams: [
          { name: "startDate", text: _.StartDate, type: "date", value: date },
          {
            name: "endDate",
            text: _.EndDate,
            type: "date",
            value: new Date(),
          },
        ],
      },
    },
  ];
  const [openModel, setOpenModel] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState(reportItems[0]);
  const toggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const getReport = (id) => {
    setSelectedReport(reportItems.find((f) => f.id === id));
  };

  return (
    <>
      <div className="sectionWrapper reports-dashboard-page orange h-100">
        <div className="row h-100">
          <div className="col reports-dashboard-container">
            <h2
              className="ml-2 reports-dashboard-header"
              // onClick={() => setOpenModel(true)}
            >
              {_.ClientHub.Reports}
            </h2>
            <div className="dashboard-container">
              <div className="dashboard-settings">
                <Dropdown
                  isOpen={dropdownOpen}
                  toggle={toggle}
                  className="dropdown-toggle portlet-menu-button"
                >
                  <DropdownToggle caret>{_.ClientHub.Reports}</DropdownToggle>
                  <DropdownMenu>
                    {reportItems.map((item) => (
                      <DropdownItem
                        key={item.id}
                        onClick={() => getReport(item.id)}
                      >
                        {item.params.reportName}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </div>
              {selectedReport && (
                <Widget
                  key={selectedReport.id}
                  Component={
                    <selectedReport.component
                      {...selectedReport.params}
                      _={_}
                    />
                  }
                  icon={"icon-omni-document"}
                  title={selectedReport.params.reportName}
                  isFlexColumn={true}
                  customDropDownMenu={false}
                />
              )}
            </div>
          </div>
        </div>

        <Modal
          visible={openModel}
          closemodal={() => setOpenModel(false)}
          type="fadeIn"
        >
          <AddWidget setOpenModel={setOpenModel}></AddWidget>
        </Modal>
      </div>
    </>
  );
};

export const mapStateToProps = ({ _ }) => ({ _ });

export default connect(mapStateToProps)(Reports);
